import axios from "axios";
import extractConsultation from "./extractConsultation";
import formatName from "./formatName";
import { amplitudeEvent } from "@/MXPixel/MedexpressAmplitude";

export default {
  methods: {
    post(data) {
      if (data && !data.questionType) {
        data.questionType = this.question.questionType;
      }

      this.$emit("answer", this.question, data);

      this.postAnswer(this.question, data);
    },
    recordAnswer(question, responseExtractor) {
      const data = {
        ...responseExtractor(question),
        questionType: question.questionType,
      };

      this.postAnswer(question, data);
    },
    postAnswer(question, data) {
      this.postToRelativeUrl(question.id, data)
        .then((response) => {
          amplitudeEvent("Consultation Answer Recorded", {
            consultation: extractConsultation(),
            name: formatName(question),
            questionId: question.id,
            disqualified: response.data.validForProduct === false,
          });
        })
        .catch(() => {
          /* ignore errors because request is not required */
        });
    },
    postToRelativeUrl(relativeUrl, data) {
      return this.postToUrl(this.submitUrl + "/" + relativeUrl, data);
    },
    postToUrl(url, data) {
      return axios.post(url, data, {
        headers: this.getCsrfHeader(this.csrfHeader, this.csrf),
      });
    },
    getCsrfHeader(csrfHeader, csrfToken) {
      const headers = {};
      headers[csrfHeader] = csrfToken;
      return headers;
    },
  },
};
